import { render, staticRenderFns } from "./KarroFinLayout.vue?vue&type=template&id=482440f0&scoped=true"
import script from "./KarroFinLayout.vue?vue&type=script&lang=js"
export * from "./KarroFinLayout.vue?vue&type=script&lang=js"
import style0 from "./KarroFinLayout.vue?vue&type=style&index=0&id=482440f0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "482440f0",
  null
  
)

export default component.exports